import Color from "color";

export { Color };
export const primary = Color("#578cf2");
export const black = Color("#000");
export const white = Color("#fff");
export const gray = Color("#ddd");
export const darkGray = Color("#222");
export const link = Color("#444");
